<template>
  <div>
    <BaseSectionHeader class="border-t pt-4 border-strong-shadow-color mb-4">
      {{ $t('Timeline') }}
    </BaseSectionHeader>
    <BaseTimeline
      :timeline="timeline"
      class="pl-2 mb-8"
    />
  </div>
</template>

<script>
import BaseSectionHeader from '../../components/BaseSectionHeader.vue';
import BaseTimeline from '../../components/BaseTimeline.vue';

export default {
  name: 'OpportunityTimeline',
  components: {
    BaseSectionHeader,
    BaseTimeline,
  },
  props: {
    timeline: {
      type: Object,
      required: true,
    },
  },
};
</script>
